import newCode from "@/../config/newCode";

const BALANCE = 0;
const WX = 1;
const ALIPAY = 2;
import API from "@/../config/api.js";

let orderDialogMixin = {
    props: {
        dialogVisible: Boolean,
        dialogLoading: Boolean,
    },
    data() {
        return {
            payParams: {
                // type是指购买方式对应的数字,发起支付请求的时候会传给后端,后端会根据它判断本次支付的方式
                // 0-购买单个报告  1-报告库包月 2-购买数据库条数 3-数据库包月 4-云豆（余额）充值 5-报告翻译
                type: undefined,
                // 支付方式(指云豆/微信/支付宝)
                payMethod: '',
                payInfo: '',
                // 二维码是否显示
                wxCodeVisible: false,
                payDisabled: false,
                // 购买的方式(指购买 数据/报告/... 的方式,如 包月/单个 购买), buyMethodName是一个字符串
                buyMethodName: '',
                // 微信支付参数
                wxParams: {
                    out_trade_no: '',
                    attach: ''
                }
            },
            wxUrl: '/wxPay/getQRCode',
            balanceUrl: '/finance/payByUserAccount',
            aliPayUrl: '/AliPay/pay',
            qrCodeLoading: false,
        }
    },
    created() {
        this.$bus.$on('qrcode-refresh', this.handleQrCodeRefresh)
        this.$bus.$on('wx-pay-success', this.handleWxPaySuccess)
    },
    destroyed() {
        this.$bus.$off('qrcode-refresh', this.handleQrCodeRefresh)
        this.$bus.$off('wx-pay-success', this.handleWxPaySuccess)
    },
    methods: {
        handleQrCodeRefresh() {
            this.showWxCodeOrPay(true)
        },
        handleWxPaySuccess() {
            this.computedDialogVisible = false;
            this.payDone()
        },
        /**
         * 用户点击支付(云豆/微信/支付宝)后的回调函数
         * @param payMethod 支付方式(指云豆/微信/支付宝)
         * @param buyMethodName 购买的方式(指购买 数据/报告/... 的方式,如 包月/单个 购买)
         * @param type type是指购买方式对应的数字,发起支付请求的时候会传给后端,后端会根据它判断本次支付的方式
         *             0-购买单个报告  1-报告库包月 2-购买数据库条数 3-数据库包月 4-云豆（余额）充值 5-报告翻译
         */
        handlePayClick(payMethod, buyMethodName, type) {
            // beforePayClick 由具体的对话框组件来实现,返回布尔值,为true则可以支付,为false则停止
            if(!this.beforePayClick(payMethod, buyMethodName, type)) {
                return
            }
            // payParams
            this.payParams.type = type
            this.payParams.buyMethodName = buyMethodName
            // 根据支付方式判断做什么
            switch (payMethod) {
                // 如果是余额支付,则弹出确认框
                case BALANCE:
                    this.balancePayConfirm()
                    break
                // 如果是微信支付,则生成展示二维码(PC)/跳转至微信(手机浏览器)/直接弹出支付框框(微信内打开)
                case WX:
                    this.showWxCodeOrPay(!this.$isMobile)
                    break
                // 如果是支付宝, 跳转至支付宝页面
                case ALIPAY:
                    this.aliPay()
                    break
            }
        },
        /**
         * beforePayClick 由具体的对话框组件来实现,返回布尔值,为true则可以支付,为false则停止,默认返回true
         * @param payMethod
         * @param buyMethodName
         * @param type
         * @returns {boolean}
         */
        beforePayClick() {
            return true
        },
        /**
         * 弹出余额支付确认对话框
         */
        balancePayConfirm() {
            this.$confirm(`需花费 ${this.params.money} 云豆，是否确定购买？`, '购买确认', {
                type: 'warning',
                customClass: 'dialog-message',
            }).then(() => {
                // 点击确认, 进行余额支付
                this.balancePay()
            }).catch(() => {
                // 点击取消, 什么也不做
            })
        },
        /**
         * 生成展示二维码(PC)/跳转至微信(手机浏览器)/直接弹出支付框框(微信内打开)
         * @param showCode 布尔值,为true则显示二维码,
         * @returns {Promise<void>}
         */
        async showWxCodeOrPay(showCode) {
            this.computedDialogLoading = true
            this.setDefaultPayParams()
            this.payParams.payMethod = 'WX'
            // 如果
            if(showCode) {
                this.payParams.wxCodeVisible = true;
                this.payParams.payInfo = "微信支付 - " + this.payParams.buyMethodName
                this.qrCodeLoading = true;
                let qrCode = document.getElementById("qrCode")
                if(qrCode) {
                    qrCode.innerText = ''
                }
            }

            let params = this.generalParams;
            let data = await this.$axiosRequest({
                url: API.getWxQRCode,
                method: "GET",
                data: params
            });
            data = data[1].data;
			console.log(data)
            if(showCode) {
                this.qrCodeLoading = false;
            }

            const WX_PC = "NATIVE";  // PC 扫码
            // const WX_WX = "JSAPI"; // 手机 微信内打开
            const WX_H5 = "MWEB"; // 手机 普通浏览器内打开
            console.log(params.tradeType);
            switch (params.tradeType) {
                // PC 扫码
                case WX_PC:
                    this.payParams.wxParams.out_trade_no = data.out_trade_no;
                    this.payParams.wxParams.attach = data.attach;
                    this.payParams.wxParams.code_url = data.code_url;
                    // 生成二维码
                    newCode()
                    break
                // // 手机 微信内打开
                // case WX_WX:
                //     if (data.redirectUrl != null && data.redirectUrl != undefined) {
                //         window.location.href = data.redirectUrl;
                //     } else {
                //         WeixinJSBridge.invoke(
                //             'getBrandWCPayRequest', {
                //                 "appId": data.appId,     //公众号名称，由商户传入
                //                 "timeStamp": data.timeStamp,         //时间戳，自1970年以来的秒数
                //                 "nonceStr": data.nonceStr, //随机串
                //                 "package": data.package,
                //                 "signType": data.signType,//微信签名方式：
                //                 "paySign": data.paySign //微信签名
                //             },
                //             (res) => {
                //                 if (res.err_msg == "get_brand_wcpay_request:ok") {
                //                     // 使用以上方式判断前端返回,微信团队郑重提示：
                //                     //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                //                     this.$message({
                //                         type: 'success',
                //                         message: "支付成功",
                //                     });
                //                     setTimeout(() => {
                //                         this.computedDialogVisible = false;
                //                         this.payDone()
                //                     }, 0);
                //                 } else if (res.err_msg == "get_brand_wcpay_request:cancel") {
                //                     this.$message({
                //                         type: 'warning',
                //                         message: "用户取消支付"
                //                     });
                //                     this.computedDialogLoading = false
                //                 } else {
                //                     this.$message({
                //                         type: 'error',
                //                         message: "支付失败"
                //                     });
                //                     this.computedDialogLoading = false
                //                 }
                //             });
                //     }
                //     if (typeof WeixinJSBridge == "undefined") {
                //         if (document.addEventListener) {
                //             document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
                //         } else if (document.attachEvent) {
                //             document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
                //             document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
                //         }
                //     } else {
                //         onBridgeReady();
                //     }
                //     break
                // // 手机 普通浏览器内打开
                case WX_H5:
                    this.payParams.out_trade_no = data.out_trade_no;
                    this.payParams.attach = data.attach;
                    // this.payParams.queryId = data.queryId;
                    this.payParams.mweb_url = data.mweb_url;
                    var url = data.domainName + this.h5WxReturnUrl();
                    window.location.href = this.payParams.mweb_url + "&redirect_url=" + encodeURIComponent(url);
                    break
            }
            this.computedDialogLoading = false
        },
        async balancePay() {
            this.payParams.payMethod = 'BALANCE'

            this.computedDialogLoading = true;
            let params = this.generalParams
			
            let {data: data} = await this.$axios.get(this.balanceUrl, {
                params: params,
            })

            // data.status状态位常量
            const FAILURE = 0;
            const SUCCESS = 1;
            const MONEY_INSUFFICIENT = 2;

            switch (data.status) {
                // 支付成功的情况
                case SUCCESS:
                    this.payDone()
                    break
                case FAILURE:
                    this.$message.error("支付失败")
                    break
                case MONEY_INSUFFICIENT:
                    this.$confirm('云豆余额不足', '支付失败', {
                        customClass: 'dialog-message',
                        confirmButtonText: '去充值',
                        cancelButtonText: '取消',
                        type: 'error',
                    }).then(() => {
                        this.$router.push({path: '/wallet'})
                    }).catch(() => {
                        this.$message('支付失败', {
                            type: "error"
                        })
                    })
                    break
            }
            this.computedDialogLoading = false;
        },
        async aliPay() {
            this.computedDialogLoading = true;
            this.payParams.payMethod = 'ALIPAY'
            let params = this.generalParams
			console.log(params);
            // const PC = 0;
            // const MOBILE = 1;
			let url = API.alipay + "?";
			for(let key in params) {
				url += key + '=' + params[key] + '&';
			}
			url += "userid=" + window.localStorage.getItem("userid")
			url += "&token=" + window.localStorage.getItem("token");
			window.location.href = url;            
            this.computedDialogLoading = false;
            // switch (params.tradeType) {
            //   case PC:
            //     break
            //   case MOBILE:
            //     break
            // }
        },
        /**
         * 支付完毕,将对话框关闭
         * 然后emit事件
         */
        payDone() {
            this.computedDialogVisible = false;
            this.$emit('pay-done')
        },

        handleDialogClose() {
            this.computedDialogVisible = false;
        },
        /**
         * 将payParams里的一些属性恢复默认值
         */
        setDefaultPayParams() {
            this.payParams.payMethod = ''
            this.payParams.payInfo = ''
            this.payParams.wxCodeVisible = false
            this.payParams.payDisabled = false
        },
        h5WxReturnUrl() {
            return ''
        }
    },
    computed: {
        generalParams() {
            if(!this.payParams.payMethod)
                return {}
            let params = {
                ...this.params,
                type: this.payParams.type,
            }
            const WX_PC = "NATIVE";  // PC 扫码
            const WX_WX = "JSAPI"; // 手机 微信内打开
            const WX_H5 = "MWEB"; // 手机 普通浏览器内打开
            const ALI_PC = "ALIPC"; // 手机 普通浏览器内打开
            const ALI_WEB = "MWEB"; // 手机 普通浏览器内打开
            switch (this.payParams.payMethod) {
                case 'WX':
                    params.tradeType = !this.$isMobile ? WX_PC : this.$isWeixin ? WX_WX : WX_H5;
                    break
                case 'BALANCE':
                    break
                case 'ALIPAY':
                    params.tradeType = !this.$isMobile ? ALI_PC : ALI_WEB
                    break
            }
            return params
        },
        computedDialogVisible: {
            get() {
                return this.dialogVisible
            },
            set(val) {
                this.$emit('update:dialogVisible', val)
            }
        },
        computedDialogLoading: {
            get() {
                return this.dialogLoading
            },
            set(val) {
                this.$emit('update:dialogLoading', val)
            }
        },

    },
    watch: {
        dialogVisible(val) {
            if(!val) {
                this.payParams.wxCodeVisible = false;
                this.payParams.payInfo = ''
            }
        }
    }
}
export default orderDialogMixin